export enum Language {
    SPANISH = "SPANISH",
    ENGLISH = "ENGLISH",
}
